/**
 * Board-Geometrie.
 *
 * Das Brett ist ein regelmäßiges Hexagon aus Hexfeldern. Bei Kantenlänge `n` ist der
 * Hexradius `n - 1` und die Feldzahl `3n(n - 1) + 1` — bei n = 9 also 217 Felder
 * (`docs/GAME_RULES.md`, Abschnitt 2).
 *
 * Die Geometrie wird **berechnet**, nicht aus `docs/board-reference.svg` eingelesen.
 * Die Grafik ist Vorlage und Testfixture (`docs/ARCHITECTURE.md` E14); der Test
 * `reference-graphic.test.ts` vergleicht beide Seiten Feld für Feld.
 *
 * Dieses Modul kennt keine Spielregeln, keine Figuren und keine Pixel.
 */
import { hexDistance, hexKey, hexRing, hexS, hex } from './hex.js';
const CENTER = hex(0, 0);
/** Das geometrische Mittelfeld. Immer `(0, 0)` — die Engine rechnet zentriert. */
export function boardCenter() {
    return CENTER;
}
export function createBoard(options) {
    const { sideLength } = options;
    if (!Number.isInteger(sideLength) || sideLength < 1) {
        throw new RangeError(`sideLength muss eine ganze Zahl ab 1 sein, war ${sideLength}`);
    }
    const radius = sideLength - 1;
    const cells = new Map();
    for (let distance = 0; distance <= radius; distance++) {
        for (const cell of hexRing(distance)) {
            cells.set(hexKey(cell), cell);
        }
    }
    return { sideLength, radius, cells };
}
/** Alle Felder, von innen nach außen ringweise geordnet. */
export function boardCells(board) {
    return [...board.cells.values()];
}
export function isOnBoard(board, cell) {
    return board.cells.has(hexKey(cell));
}
/**
 * Feld der Außenreihe. Bei einem regelmäßigen Hexagon gleichbedeutend damit, dass
 * das Feld mindestens einen Nachbarn außerhalb des Bretts hat.
 */
export function isEdgeCell(board, cell) {
    return isOnBoard(board, cell) && hexDistance(CENTER, cell) === board.radius;
}
/**
 * Eines der sechs Eckfelder. Ecken liegen auf der Außenreihe und haben eine
 * Cube-Komponente gleich null — sie sind `radius * HEX_DIRECTIONS[i]`.
 */
export function isCornerCell(board, cell) {
    if (!isEdgeCell(board, cell))
        return false;
    return cell.q === 0 || cell.r === 0 || hexS(cell) === 0;
}
//# sourceMappingURL=board.js.map